import { FIELD_ERROR_VALIDITY } from 'modules/settings/components/custom-notifications/custom-notification-form.validation';
import type { PocInputValidity } from 'commons/types';
import { ExtendedValidationMessages } from 'commons/components';
import { TFunction } from 'core/i18n/i18n';

export type CustomAlarmsFormValidationMessages = {
    name: ExtendedValidationMessages;
    events: ExtendedValidationMessages;
    windowDays: ExtendedValidationMessages;
};

export const getCustomAlarmsFormValidationMessages = (t: TFunction): CustomAlarmsFormValidationMessages => ({
    name: {
        error: {
            custom: t('settings.devices.custom-alarms.create.modal.name.error.required'),
            duplicated: t('settings.devices.custom-alarms.create.modal.name.error.duplicated'),
        },
    },
    events: {
        error: {
            custom: t('settings.devices.custom-alarms.create.modal.events.error.required'),
        },
    },
    windowDays: {
        error: {
            custom: t('settings.devices.custom-alarms.create.modal.window.error.invalid'),
        },
    },
});

export const getEventsDropdownValidity = (
    submitAttempted: boolean,
    eventsValid: boolean,
    draftCount: number
): PocInputValidity | undefined => {
    if (!submitAttempted) {
        return undefined;
    }

    if (!eventsValid && draftCount === 0) {
        return FIELD_ERROR_VALIDITY;
    }

    return { state: 'valid' };
};
